import { CSSProperties, useEffect, useState } from "react";

export function usePageFlip() {
  const [flipDirection, setFlipDirection] = useState<-1 | 0 | 1>(0);

  useEffect(() => {
    let flipTimeout: ReturnType<typeof setTimeout> | null = null;
    if (flipDirection !== 0) {
      flipTimeout = setTimeout(() => {
        setFlipDirection(0);
      }, 400);
    }

    return () => {
      if (flipTimeout !== null) clearTimeout(flipTimeout);
    };
  }, [flipDirection]);

  return {
    flipDirection,
    flipLeft: () => {
      setFlipDirection(-1);
    },
    flipRight: () => {
      setFlipDirection(1);
    },
  };
}

export default function PageFlip({
  flipDirection,
  cardStyle = {},
}: {
  flipDirection: -1 | 0 | 1;
  cardStyle?: CSSProperties;
}) {
  return (
    <div
      className="absolute top-[15dvh] left-[5dvw] z-10 w-[90dvw] h-[80dvh] rounded-[22px] shadow-[rgba(0,0,0,0.2)_0px_2px_2px] origin-[50%_80%] opacity-50 bg-white"
      style={{
        ...cardStyle,
        display: flipDirection === 0 ? "none" : "flex",
        animation:
          flipDirection === -1
            ? "flipCardLeft 0.5s ease-in forwards"
            : flipDirection === 1
              ? "flipCardRight 0.5s ease-in forwards"
              : "unset",
      }}
    />
  );
}
